export const translation = {
  app: {
    gettingStarted: `Use the "Picks" section on the menu to the right to get started.`,
    welcome: `Welcome to parlaypicker`,
    welcomePartOne: `us`,
    footer: `parlaypicker.us is wholly owned by FTFi Ventures, LLC, © 2026, all rights reserved.`,
    eq: {
      rising: `eq index is on the rise`,
      hot: `eq index is hot! this is a breakout pick`,
      caution: `eq index is trending down, caution!`,
    },
    buttons: {
      continue: `Continue`,
      submit: `Submit`,
      back: `Back`,
      cancel: `Cancel`,
      generate: `Generate`,
    },
    lockPick: {
      text: `LOCK PICK`,
      desc: `All-time pick hit rate based on customer's selected game picks.`,
      tmPre: `Our picks are a`,
      tmPost: `, are yours?`,
      titleDesc: `We consider this pick to be a LOCK, or a high probability of hitting.`,
    },
    splash: {
      header: `Our picks are a lock, are yours?`,
      info: `At parlaypicker.us, we've created the world's first, revolutionary learning`,
      infoPartOne: ` which focuses solely on same-game, 3 leg parlay picks based on your level of desired risk.`,
      infoPartTwo: ` is our bread & butter, these picks are what we consider "locks", or with odds stacked in your favor. Nothing in life is a guarantee, but these picks hit more often than they do not, all thanks to our revolutionary`,
      infoPartThree: ` We automatically track, update, & share this success rate with you in the tracker below.`,
      signIn: `Sign up or sign in below to get started.`,
    },
  },
  pages: {
    invite: {
      info: `are you ready...`,
      infoPartTwo: `...to be the`,
      infoPartThree: `house`,
      infoPartFour: `advantage?`,
      infoPartFive: `Looking to get started? Ask your friends for an invite!`,
      buttonText: `Accept invite`,
    },
    pricing: {
      headerText: `Pricing`,
      headerSubtext: `Disclosure: Please allow up to 24 hours for your account to reflect changes after purchase. If you have any questions, please reach out to us at support@parlaypicker.us`,
      currentPlan: `Your current plan`,
      contactUs: `Contact Us`,

      freePlan: `Free`,
      freePlanPrice: `$0/month`,
      freePlanFeature1: `Unlimited access to same-game parlay picks for all supported sports per day`,
      freePlanFeature2: `Free Plan includes unlimited access to Risky & 50/50 picks`,
      freePlanFeature3: `Real-time updates on pick performance and hit rates`,

      proPlan: `Pro`,
      proPlanPrice: `$99/year`,
      proPlanFeature1: `Access to all Free Plan features...`,
      proPlanFeature2: `Pro Plan includes one`,
      proPlanFeature2Pt2: `per sport per day, every day`,
      proPlanFeature4: `Pro Plan members additionally receive five user invites per month to invite your friends to parlaypicker.us`,
      proPlanCTA: `Purchase Pro`,

      elitePlan: `Elite`,
      elitePlanPrice: `Billed Annually`,
      elitePlanFeature1: `Use the Contact form and explain your use-case, we'll review & get back to you!`,
      elitePlanFeature2: `You're an expert that`,
      elitePlanFeature2Pt2: `the house advantage...`,
      elitePlanFeature3: `Access to`,
      elitePlanFeature3Pt2: `, all the time, no limits, no extra fees`,
      elitePlanFeature4: `Access to Pick Insights to see pick trends & performance`,
      elitePlanFeature5: `Access to the daily Cream of the Crop`,
      elitePlanFeature6: `Most importantly, access to Our Bet strategy!`,
      elitePlanCTA: `Purchase Elite`,
    },
    home: {
      header: `Welcome to parlaypicker.`,
      welcomePartOne: `us`,
      listTitle: `Quick start guide`,
      listItemOne: `Select an available sport`,
      listItemTwo: `Filter by desired risk level`,
      listItemThree: `Well done! Our`,
      listItemFour: `will take it from here`,
      lockpick: `LOCK PICK`,
      lockpickDesc: `This percentage represents the live hit rate of our selected picks with a Lock risk level, as close as you'll get to a guarantee!`,
      lockpickHeader: `Lock Hit Performance`,
      trending: {
        free: `See trending picks only as a Pro or Elite Plan member!`,
        header: `Trending Picks`,
      },
    },
    about: {
      header: `How It Works`,
      headerSubtext: `The platform, the myth, the legend!`,
      prePre: `Unaffiliated & independent, our goal is to making `,
      pre: ` the house advantage. We aim to provide the guidance for a consistent 7 out of 10 days of hitting your same-game parlay (SGP) picks.`,
      info: `At parlaypicker.us, we've created the world's most incredible sports entertainment prediction platform, our`,
      infoPartOne: ` a proprietary learning platform which focuses solely on same-game parlay (SGP) picks.`,
      infoPartTwo: ` is parlaypicker.us secret sauce, these picks are what we consider "locks", or with odds stacked in your favor. Nothing in life is a guarantee, but these picks hit more often than they do not, all thanks to our revolutionary`,
      infoPartThree: `We're so convinced in our platform's abilities, that we automatically track, update, & share this hit rate with you in the tracker on the home page for all users.`,
      infoPartFour: `Disclosure: Remember, parlaypicker.us is not a gambling site. The suggestions made are simply that, suggestions based on a proprietary empirical analysis from our learning platform. Parlaypicker.us offers no guarantees and assumes zero liability or responsibility for the useage of said suggestions, we merely provide them to you, to use at your own risk and discretion.`,
    },
    picks: {
      headerText: `Picks`,
      headerSubtext: `Select a sport to see available picks, use the filters to narrow your search. Tap a pick for more details!`,
      freeInfo: `Upgrade to Elite to see daily lock picks in this list!`,
      noResults: `No picks match these filters.`,
      loadMore: `Load more picks`,
      tabs: {
        sportsHeader: `Select a sport to continue.`,
        selectedGameHeader: `Click "Generate" to generate parlay picks for this game.`,
        gamesHeader: `Available games today.`,
        noGamesHeader: `No games available today for this sport.`,
      },
      pickFilters: {
        numLegs: `Number of legs`,
        riskLevel: `Risk level`,
        picksCreated: `Picks created`,
        gameDate: `Game date`,
        favorite: `Favorites`,
      },
      game: {
        select: `Game Picks`,
        picks: {
          header: `Projected overall odds:`,
          risk: `Risk Level:`,
          calculator: `Parlay calculator`,
          amount: `Bet amount $`,
          earnings: `Estimated winnings: `,
          payout: `Total payout: `,
        },
        info: {
          lockDesc: `As close as you'll get to a guarantee, these picks hit more often than they do not.`,
          fiftyDesc: `Even odds, you'll lose as often as you'll win, more or less.`,
          riskyDesc: `Bet small and hope for the best return, these are statisically very unlikely picks.`,
        },
      },
      pickDetail: {
        noResults: `No picks found for this game.`,
        loading: `Loading pick details...`,
        refreshButton: `Refresh`,
        backButton: `Return`,
      },
    },
    pickInsights: {
      headerText: `Pick Insights`,
      headerSubtext: `See our most recent Lock pick hit trends`,
      freeInfoText: `Upgrade to Elite to see our most recent Lock pick hit trends, only available to Elite Plan members.`,
    },
    todaysPick: {
      headerText: `Cream of the Crop`,
      headerSubtext: `...Rises to the top! Purely by the odds, this represents our best overall Lock's across today's remaining games. Find trending picks here & snatch a house advantage! Tap a pick for details.`,
      freeInfoText: `Upgrade to Elite to see today's Cream of the Crop, only available to Elite Plan members.`,
      noResults: `Nothing available at the moment, check back tomorrow!`,
      buttonText: `See all picks`,
    },
    ourBet: {
      headerText: `Our Bet`,
      hitRateHeaderText: `Our Bet Hit Rate`,
      hitRateHeaderSubText1: `Real money results!`,
      hitRateHeaderSubText2: `The live performance of our real bets using parlaypicker.us own`,
      hitRateHeaderSubText3: `risk level picks, updated daily!`,
      headerSubtext: `If there's a Lock pick worth betting on today, here's where we're putting our money...we're not only the creator, but also its #1 user! Tap a pick for details.`,
      freeInfoText: `Upgrade to Elite to see Our Bet, only available to Elite Plan members.`,
      noResults: `Nothing available at the moment, check back tomorrow!`,
      buttonText: `See all picks`,
    },
    contact: {
      header: `Contact Us`,
      required: `Required field`,
      headerText: `Questions or feedback? Shoot us a message and we'll get back to you!`,
      fields: {
        firstN: `First name`,
        lastN: `Last name`,
        email: `Email address`,
        message: `Message`,
        agree: `By checking this box you agree to our contact terms and conditions.`,
      },
    },
    account: {
      header: `My Account`,
      headerSubtext: `Update your account information & utilize any plan invites below. Looking to manage your subscription? Please reach out to support@parlaypicker.us`,
      required: `Required field`,
      invites: {
        inviteHeader: 'Monthly Invites',
        remaining: `Invites remaining:`,
        inviteEmail: `Invite email address`,
        sendInvite: `Send Invite`,
        disclaimer: `Disclaimer: By sending an invite, you agree to our terms and conditions, all invites are manually reviewed & subject to approval.`,
      },
      fields: {
        firstN: `First name`,
        lastN: `Last name`,
        email: `Email address`,
        phone: `Phone number`,
        address1: `Address 1`,
        address2: `Address 2`,
        state: `State`,
        zip: `Zip code`,
        country: `Country`,
        agree: `By checking this box you confirm this information is accurate to your knowledge.`,
      },
    },
  },
  nav: {
    home: `Home`,
    pricing: `Pricing`,
    picks: `Picks`,
    pickInsights: `Pick Insights`,
    myAccount: `My Account`,
    about: `How It Works`,
    contact: `Contact Us`,
    loggedInUser: `Welcome!`,
    signOut: `Log Out`,
    ourBet: `Our Bet`,
    todaysPick: `Cream of the Crop`,
    badges: {
      free: `Free`,
      pro: `Pro`,
      elite: `Elite`,
    },
  },
};
